import { toast } from "react-toastify";
import HttpClient from "./HttpClient";

//  POST METHOD
export const post = async (url, data) => {
  try {
    let res = await HttpClient.post(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

//PATCH METHOD
export const patch = async (url, data) => {
  try {
    let res = await HttpClient.patch(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// GET METHOD
export const get = async (url, data) => {
  try {
    let res = await HttpClient.get(url);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

//PUT METHOD
export const put = async (url, data) => {
  console.log("url, data", url, data);

  try {
    let res = await HttpClient.put(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// DELETE METHOD
export const deletes = async (url, data) => {
  try {
    let res = await HttpClient.delete(url, data);
    return PrepareResponse(res);
  } catch (error) {
    return HandleException(error);
  }
};

// // FILE IMAGE POST METHOD
// export const file_post = async (url, data) => {
//   try {
//     let res = await httpClientForm.post(url, data);
//     return PrepareResponse(res);
//   } catch (error) {
//     return HandleException(error);
//   }
// };

// FOR RESPONCSE
const PrepareResponse = (res) => {
  if (res?.status) {
    let { status, data } = res;
    if (status >= 200 && status <= 299) {
      if (data.status == "success") {
        return data;
      } else if (data.status == true) {
        return data;
      } else if (data.status == "failure") {
        return data;
      } else if (data.status == "empty") {
        return data;
      } else if (data.status == "error") {
        alert(data?.message);
        return data;
      } else {
        return data;
      }
    } else {
      alert(`message: ${data?.message}`);
    }
  } else {
    alert("");
  }
  return {};
};

// FOR ERROR HANDLE
const HandleException = (err) => {
  console.log("from handleException", err);
  try {
    if (err?.response?.data) {
      let { data, status, statusText, config, headers, request, message } =
        err.response;
      if (status == 400) {
        if (data?.errors) {
          // toast.error(data?.message + " " + data?.errors);
          toast.error(data?.message);
        } else {
          toast.error(data?.message || data?.detail);
        }

        return data;
      } else if (status == 401) {
        toast.error("You have already logged in another device");
        setTimeout(() => {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        }, 2000);
      } else if (status == 404) {
        toast.error(
          data?.message
            ? data?.message
            : data?.detail
              ? data?.detail
              : "Page not found",
        );
      } else {
        toast.error(`status  retruns ${data?.message}`);
      }
    } else {
      console.log("Something went wrongcheck or check your internet");
    }
  } catch (error) {
    // toast.error("Someting went wrong or check your internet");
  }
  return {};
};
